/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{position:fixed;top:0;right:0;width:100%}[_nghost-%COMP%]   .alert-wrapper[_ngcontent-%COMP%]{position:absolute;top:58px;right:20px}"];
export { styles as styles };
